import { compose } from 'redux'
import { connect } from 'react-redux'
import withType from 'components/common/hoc/withType'
import BOTRelatedArticles from './BOTRelatedArticles'
import { getRelatedArticles } from '../selectors'

const mapStateToProps = state => ({
  relatedArticles: getRelatedArticles(state)
})

export default compose(
  withType({ type: 'BOTRelatedArticles' }),
  connect(mapStateToProps)
)(BOTRelatedArticles)
